import { staticsUrl } from '../../../config';

export default function HotPointsScripts(context) {
  const {
    hotPoints, precision, canvasRef, imgWrapRef, canvasWrapRef, textRef, setZoom, img1Refs, img2Refs, pointerRef, getZoom
  } = context;
  let mouseX = 0;
  let mouseY = 0;
  let blinkTimeout, scToVInterval, scrollTimeout;

  const mouseMove = (e) => {
    mouseX = e.pageX;
    mouseY = e.pageY;
  }

  // Sets the zoom to best fit the device and layout
  const setInitialZoom = () => {
    let zoomXY = getoptimalZoom();
    if (zoomXY > 2) zoomXY *= 0.9;
    zoomXY = Math.min(zoomXY, 3);
    zoomXY = Math.max(zoomXY, 1.5);
    setZoom(zoomXY);
  };

  // returns true if image fits the windows with no scrollbars
  // const isFitImage = () => {
  //   return getoptimalZoom() <= getZoom();
  // }

  // Returns zoom covering entire window
  const getoptimalZoom = () => {
    const width = imgWrapRef.current.clientWidth;
    const height = imgWrapRef.current.clientHeight;
    const zoomX = width / hotPoints.width;
    const zoomY = height / hotPoints.height;
    return Math.min(zoomX, zoomY);
  }

  // Stop binking image for all words
  const stopBlinkAll = () => {
    hotPoints.words.forEach((word, idx) => {
      const imgRef = img1Refs[idx];
      if (imgRef.current) imgRef.current.className = imgRef.current.className.replace(/\bblink\b/g, '');
    });
  }

  // Stop binking image for given word
  // const stopBlinkWord = (wordOrIdx) => {
  //   const imgRef = getImg1ref(wordOrIdx);
  //   imgRef.current.className = imgRef.current.className.replace(/\bblink\b/g, '');
  // }

  // Blink image for given word
  const blinkWord = (wordOrIdx, time = 0) => {
    const imgRef = getImg1ref(wordOrIdx);
    imgRef.current.classList.add("blink");
    if (time) {
      blinkTimeout = setTimeout(() => {
        stopBlinkAll();
      }, time);
    }
  }

  // Blink image for given word
  const flashWord = (wordOrIdx) => {
    showImg1(wordOrIdx);
    blinkTimeout = setTimeout(() => {
      hideAll();
    }, 1000);
  }

  // find img1 ref for given word
  const getImg1ref = (wordOrIdx) => {
    if (Number.isInteger(wordOrIdx)) {
      return img1Refs[wordOrIdx];
    }
    const idx = getIdx(wordOrIdx)
    return img1Refs[idx];
  }

  // find img2 ref for given word
  const getImg2ref = (wordOrIdx) => {
    if (Number.isInteger(wordOrIdx)) {
      return img2Refs[wordOrIdx];
    }
    const idx = getIdx(wordOrIdx)
    return img2Refs[idx];
  }

  // Returns true/false if image clicked within precision
  const isWordClicked = (wordOrIdx) => {
    const word = getWord(wordOrIdx);
    const words = findClickedWords();
    return !!words.find(item => item.text === word.text);
  }

  // Sets text
  const setText = (textWordOrIdx) => {
    let text;
    switch (typeof textWordOrIdx) {
      case 'number':
        text = getWord(textWordOrIdx).text;
        break;
      case 'object':
        text = textWordOrIdx.text;
        break;
      case 'string':
        text = textWordOrIdx;
        break;
      default:
        text = '&nbsp;';
    }
    textRef.current.innerHTML = text;
  }

  // Zwraca obiekt word po dostarczeniu idx
  const getWord = (wordOrIdx) => {
    if (!Number.isInteger(wordOrIdx)) return wordOrIdx;
    return hotPoints.words[wordOrIdx];
  }

  // Zwraca idx
  const getIdx = (wordOrIdx) => {
    if (Number.isInteger(wordOrIdx)) return wordOrIdx;
    let idx;
    hotPoints.words.forEach((_word, _idx) => {
      if (_word.text === wordOrIdx.text) idx = _idx;
    });
    return idx;
  }

  // hides images for given word
  const hide = (wordOrIdx) => {
    const img1 = getImg1ref(wordOrIdx);
    const img2 = getImg2ref(wordOrIdx);
    img1.current.style.opacity = 0;
    if (img2.current) img2.current.style.opacity = 0;
  }

  // hides images for given word
  const hideImg2 = (wordOrIdx) => {
    const img2 = getImg2ref(wordOrIdx);
    if (img2.current) img2.current.style.opacity = 0;
  }

  // hides all word images
  const hideAll = () => {
    hotPoints.words.forEach(word => hide(word));
  }

  // shows images for given word
  // const show = (wordOrIdx) => {
  //   showImg1(wordOrIdx);
  //   showImg2(wordOrIdx);
  // }

  // shows images for given word
  const showImg1 = (wordOrIdx) => {
    const img1 = getImg1ref(wordOrIdx);
    img1.current.style.opacity = 1;
  }

  // shows images for given word
  const showImg2 = (wordOrIdx) => {
    const img2 = getImg2ref(wordOrIdx);
    if (img2.current) img2.current.style.opacity = 1;
  }

  // shows images for given word
  const img2Present = (wordOrIdx) => {
    const img2 = getImg2ref(wordOrIdx);
    return !!img2.current;
  }

  // shows images for all the words
  const showAll = () => {
    hotPoints.words.forEach(word => showImg1(word));
  }

  // shows images for all the words
  const showAllImg1 = () => {
    hotPoints.words.forEach(word => showImg1(word));
  }

  // shows images for all the words
  const hideAllImg2 = () => {
    hotPoints.words.forEach(word => hideImg2(word));
  }

  // find nearest clicked image (one)
  const findClicked = () => {
    const { x, y } = getClickedXY();
    let precisionX = 0;
    let result = [];
    const mapImg = img => {
      return { ...img, fill: getImgData(x, y, img, precisionX) };
    }
    while (precisionX <= precision && result.length === 0) {
      const imagesClicked = findImages(x, y, precisionX);
      result = imagesClicked.map(mapImg);
      result = result.filter(img => img.fill > 0);
      precisionX++;
    }
    return result.length ? result[0] : false;
  }

  // Return array of words found within precision
  const findClickedWords = () => {
    const { x, y } = getClickedXY();
    const imagesClicked = findImages(x, y, precision);
    let result = imagesClicked.map(img => {
      return { ...img, fill: getImgData(x, y, img, precision) };
    });
    return result.filter(img => img.fill > 0);
  }

  // Scrolls given word to view based on Img1
  const scrollToImg1 = (wordOrIdx, callback) => {
    const word = getWord(wordOrIdx);
    scrollImgToView(word.mainImg, callback);
  }

  // Scrolls given word to view based on Img2
  const scrollToImg2 = (wordOrIdx, callback) => {
    const word = getWord(wordOrIdx);
    scrollImgToView(word.secondaryImg, callback);
  }

  // scroll to Img2 then to Img1
  const scrollImg2ToImg1 = (wordOrIdx) => {
    destruct();
    scrollTimeout = scrollToImg2(wordOrIdx, () => {
      setTimeout(() => {
        scrollToImg1(wordOrIdx);
      }, 750);
    })
  }

  // Depending on whether Img2 is present choose scroll mode
  const scrollToImg = (wordOrIdx) => {
    if (img2Present(wordOrIdx)) {
      scrollImg2ToImg1(wordOrIdx);
    } else {
      scrollToImg1(wordOrIdx);
    }
  }

  // Scrolls given word to view based on Img2
  const scrollImgToView = (img, done = () => { }) => {

    const $wrap = canvasWrapRef.current;
    const wrapWidth = $wrap.clientWidth;
    const wrapHeight = $wrap.clientHeight;

    const $img = imgWrapRef.current;
    const imgWidth = $img.clientWidth;
    const imgHeight = $img.clientHeight;

    const maxScrollX = wrapWidth - imgWidth;
    const maxScrollY = wrapHeight - imgHeight;

    const x = Math.floor((img.x + img.width / 2) * getZoom()); // OK :)
    const y = Math.floor((img.y + img.height / 2) * getZoom()); // OK :)

    const scrollX = Math.floor(Math.max(0, Math.min(maxScrollX, x - imgWidth / 2)));
    const scrollY = Math.floor(Math.max(0, Math.min(maxScrollY, y - imgHeight / 2)));

    $img.scrollLeft = scrollX;
    scToVInterval = setInterval(() => {
      if ($img.scrollLeft === scrollX) {
        clearInterval(scToVInterval);
        $img.scrollTop = scrollY;
        done();
      }
    }, 100);
  }

  // Returns X and Y coordinates of clicked image no matter the zoom and scroll
  const getClickedXY = () => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = Math.floor((mouseX - rect.x) / getZoom());
    const y = Math.floor((mouseY - rect.y - scrollTop()) / getZoom());
    return { x, y };
  }

  // Znajdowanie obrazków z grubsza - ramka
  const findImages = (x, y, precision) => {
    const result = [];
    hotPoints.words.forEach(word => {
      const img = word.mainImg;
      if (
        img.x - precision <= x &&
        img.x + img.width + precision >= x &&
        img.y <= y + precision &&
        img.y + img.height + precision >= y
      ) {
        result.push({ ...word });
      }
    })
    return result;
  }

  // Zbieranie danych z danego obszaru obrazka
  const getImgData = (x, y, word, precision) => {
    const imgData = word.mainImg;
    const xPos = x - imgData.x;
    const yPos = y - imgData.y;
    const data = imgData.context.getImageData(xPos - precision, yPos - precision, 1 + precision * 2, 1 + precision * 2);
    return getFill(data.data);
  }

  // Znajdowanie czy są jakieś nieprzeźroczyste piksele w danym obszarze
  const getFill = (arr) => {
    let result = 0;
    const len = arr.length / 4;
    for (let i = 0; i < len; ++i) {
      let fill = Math.ceil((arr[i * 4] + arr[i * 4 + 1] + arr[i * 4 + 2]) * arr[i * 4 + 3]);
      result += fill;
      if (result > 255) break;
    }
    return result;
  };

  // Position correctly circle pointer
  const setPointer = (no) => {
    const img = hotPoints.words[no].mainImg;
    const left = img.x + Math.floor(img.width / 2) - 50;
    const top = img.y + Math.floor(img.height / 2) - 50;
    pointerRef.current.style.left = left;
    pointerRef.current.style.top = top;
  }

  // Odgrywa dźwięk dla określonego wyrazu
  const play = (wordOrIdx) => {
    const word = getWord(wordOrIdx);
    if (word) context.play(staticsUrl + word.mp3Url);
  }

  // Cleans the context
  const destruct = () => {
    clearTimeout(blinkTimeout);
    clearTimeout(scrollTimeout);
    clearInterval(scToVInterval);
  }

  return {
    mouseMove,
    setInitialZoom,
    scrollToImg1,
    scrollImg2ToImg1,
    scrollToImg,
    isWordClicked,
    findClicked,
    destruct,
    hideAllImg2,
    img2Present,
    blinkWord,
    stopBlinkAll,
    setText,
    play,
    setPointer,
    showImg1,
    showImg2,
    showAll,
    hide,
    showAllImg1,
    hideAll,
    flashWord,
  }
}

function scrollTop() {
  let t;
  return (((t = document.documentElement) || (t = document.body.parentNode)) && typeof t.scrollTop == 'number' ? t : document.body).scrollTop;
}